import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {Button, Card, Col, Form, Icon, Input, Row} from "antd";
import {login} from "./actions";
import "./LoginPage.css";

const FormItem = Form.Item;

const formItemLayout = {
  labelCol: {
    xs: {span: 24},
    sm: {span: 8},
  },
  wrapperCol: {
    xs: {span: 24},
    sm: {span: 16},
  },
};

class LoginPage extends Component {
  componentDidUpdate(prevProps) {
    const {token, history} = this.props;
    const { from } = this.props.location.state || { from: { pathname: "/" } };
    if (token && token !== prevProps.token) history.replace(from);
  }

  _login = (e) => {
    e.preventDefault();
    const {form, login} = this.props;
    form.validateFieldsAndScroll((err, values) => {
      if (!err) login(values);
    });
  };

  render() {
    const {form: {getFieldDecorator}, loading, error} = this.props;
    const errorMessage = error && error.message && error.message.split(":")[0];
    const layout = {
      xs: {span: 24},
      sm: {span: 20, offset: 2},
      md: {span: 16, offset: 4},
      lg: {span: 12, offset: 6},
      xl: {span: 8, offset: 8},
    };

    return <Row id="loginPage" gutter={0} justify="center"><Col {...layout}>
      <Card title="Kokopelli Login">
        <Form>
          <FormItem label="Username" {...formItemLayout}>
            {getFieldDecorator('username', {
              initialValue: '',
              rules: [{required: true, type: 'string', message: 'Username is required'}],
            })(
              <Input autoFocus prefix={<Icon type="user" style={{color: 'rgba(0,0,0,.25)'}}/>} placeholder="Username"/>
            )}
          </FormItem>
          <FormItem label="Password" {...formItemLayout}>
            {getFieldDecorator('password', {
              initialValue: '',
              rules: [{required: true, type: 'string', message: 'Password is required'}],
            })(
              <Input type="password" prefix={<Icon type="lock" style={{color: 'rgba(0,0,0,.25)'}}/>} placeholder="Password"/>
            )}
          </FormItem>
          <div className="login-error">{errorMessage}</div>
          <Button loading={loading} type="primary" onClick={this._login}>Login</Button>
        </Form>
      </Card>
    </Col></Row>;
  }
}
LoginPage.propTypes = {
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  token: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.object,
  login: PropTypes.func.isRequired,
};

const LoginPageForm = Form.create()(LoginPage);

const mapStateToProps = state => ({
  token: state.auth.token,
  loading: state.auth.loading,
  error: state.auth.error,
});
const mapDispatchToProps = dispatch => ({
  login: bindActionCreators(login, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginPageForm);



// WEBPACK FOOTER //
// ./src/Auth/LoginPage.js